module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitlef"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    staticClass: "ts2"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_time"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_prologue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("1.")]), _vm._v(" Background")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("2.")]), _vm._v(" A Dirty, Distant War")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("3.")]), _vm._v(" First Impressions")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("4.")]), _vm._v(" Covering the War")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("5.")]), _vm._v(" More American Involvement")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("6.")]), _vm._v(" The Legend of the Bearded One")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("7.")]), _vm._v(" Military Advisory Group")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("8.")]), _vm._v(" Central American Crisis")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt1"
  }, [_vm._v("9.")]), _vm._v(" No Man’s Land")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tt2"
  }, [_vm._v("10.")]), _vm._v(" US Military Assistance Command")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapEntryf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0